const RegionData = {
    actionMsg: 1,
    Message: "Data Fetched",
    regionlist: [
      {
        
        id: "MQ",
        name: "Americas",
        image: "https://files.saassrs.com/backend/upload/20241202141213.jpg",
        autoId: 1,
      },
      {
        branch: "APAC",
        id: "Mg",
        name: "Asia Pacific",
        image: "https://files.saassrs.com/backend/upload/20241202141243.jpg",
        autoId: 2,
      },
      {
        id: "Mw",
        name: "ANZ | Australia",
        image: "https://files.saassrs.com/backend/upload/20241202141205.jpg",
        autoId: 3,
      },
      {
        id: "NA",
        name: "Europe",
        image: "https://files.saassrs.com/backend/upload/20241202141225.webp",
        autoId: 4,
      },
      {
        id: "NQ",
        name: "Middle East",
        image: "https://files.saassrs.com/backend/upload/20241202141245.webp",
        autoId: 5,
      },
      {
        id: "Ng",
        name: "Africa",
        image: "https://files.saassrs.com/backend/upload/20241202141217.webp",
        autoId: 6,
      },
    ],
  };
  
  export default RegionData;
  